<template>
  <div class="solution">
    <div class="bannder">
      <img src="@/assets/dailijiameng.png" alt />
    </div>
    <div class="container container3">
      <div class="container4">
        <div class="headers">
          <div class="headerdiv">代理加盟</div>
        </div>
        <form>
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">
                <span class="glyphicon glyphicon-user"></span>
              </div>
              <input type="text" class="form-control" id="exampleInputEmail1" placeholder="您的姓名" />
            </div>
          </div>
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">
                <span class="glyphicon glyphicon-earphone"></span>
              </div>
              <input type="text" class="form-control" id="exampleInputEmail1" placeholder="您的电话" />
            </div>
          </div>
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">
                <span class="glyphicon glyphicon-envelope"></span>
              </div>
              <div class="row">
                <div class="col-md-9">
                  <input
                    type="text"
                    class="form-control"
                    id="exampleInputEmail1"
                    placeholder="请输入短信验证码"
                  />
                </div>
                <div class="col-md-3">
                  <button type="submit" class="btn btn-primary">获取验证码</button>
                </div>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary" style="width : 100% ; height : 50px;">立即加入</button>
        </form>
      </div>
    </div>
    <div class="container">
      <div class="headers">
        <div class="headerdiv">加盟流程</div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="hezi"></div>
        </div>
        <div class="col-md-3">
          <div class="hezi"></div>
        </div>
        <div class="col-md-3">
          <div class="hezi"></div>
        </div>
        <div class="col-md-3">
          <div class="hezi"></div>
        </div>
        <div class="col-md-3">
          <div class="hezi"></div>
        </div>
        <div class="col-md-3">
          <div class="hezi"></div>
        </div>
        <div class="col-md-3">
          <div class="hezi"></div>
        </div>
        <div class="col-md-3">
          <div class="hezi"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.solution {
  z-index: 2;
  .bannder {
    width: 100%;
    height: 100%;
    margin-bottom: 200px;
    img {
      width: 100%;
      margin: 0 auto;
    }
  }
  .container3 {
    position: absolute;
    z-index: 888;
    top: 50%;
    left: 50%;
    margin-left: -450px;
    .container4 {
      width: 900px;
      text-align: center;
      background: #f2f2f2;
      padding: 50px;
      border-radius: 8px;
      .form-group {
        margin: 30px 0;
      }
    }
  }
}
.hezi {
  width: 180px;
  height: 180px;
  margin: 30px auto;
  background: #979797;
}
.headers {
  width: 100%;
  height: 100px;
  font-size: 40px;
  color: rgba(51, 51, 51, 1);
  line-height: 100px;
  text-align: center;
}
.headerdiv {
  width: 430px;
  margin: 0 auto;
  position: relative;
}
.headerdiv:before,
.headerdiv:after {
  position: absolute;
  background: #333333;
  content: "";
  height: 2px;
  top: 50%;
  width: 100px;
}
.headerdiv:before {
  right: 10px;
}
.headerdiv:after {
  left: 10px;
}
</style>

